module.exports = __webpack_public_path__ + "static/media/bg.dc93d252.jpg";